export default {"src":"/_next/static/media/live-sports.7ffe6198.svg","height":23,"width":32,"blurWidth":0,"blurHeight":0};